/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2021-03-24 09:58:07
 */

import Cookies from 'js-cookie'
// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'homepage_token'
export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const removeToken = () => Cookies.remove(tokenKey)

const userRole = 'user_role'
export const getUserRole = () => Cookies.get(userRole)
export const setUserRole = (role: string) => Cookies.set(userRole, role)
export const removeUserRole = () => Cookies.remove(userRole)

const idCardNo = 'id_card'
export const getIdCardNo = () => Cookies.get(idCardNo)
export const setIdCardNo = (id: string) => Cookies.set(idCardNo, id || '')
export const removeIdCardNo = () => Cookies.remove(idCardNo)

const userName = 'user_name'
export const getUserName = () => Cookies.get(userName)
export const setUserName = (name: string) => Cookies.set(userName, name || '')
export const removeUserName = () => Cookies.remove(userName)

const userPortrait = 'user_portrait'
export const getUserPortrait = () => Cookies.get(userPortrait)
export const setUserPortrait = (portrait: string) => Cookies.set(userPortrait, portrait || '')
export const removeUserPortrait = () => Cookies.remove(userPortrait)

const isCertification = 'is_certification'
export const getUserIsCertification = () => Cookies.get(isCertification)
export const setUserIsCertification = (status: string) => Cookies.set(isCertification, JSON.stringify(status))
export const removeUserIsCertification = () => Cookies.remove(isCertification)

const userPhone = 'user_phone'
export const getUserPhone = () => Cookies.get(userPhone)
export const setUserPhone = (phone: string) => Cookies.set(userPhone, JSON.stringify(phone))
export const removeUserPhone = () => Cookies.remove(userPhone)

const orgId = 'org_id'
export const getOrgId = () => Cookies.get(orgId)
export const setOrgId = (id: string) => Cookies.set(orgId, id)
export const removeOrgId = () => Cookies.remove(orgId)

const needCertification = 'need_certification'
export const getNeedCertification = () => Cookies.get(needCertification)
export const setNeedCertification = (value: boolean) => Cookies.set(needCertification, value ? 'true' : 'false')
export const removeNeedCertification = () => Cookies.remove(needCertification)

const manual = 'manual'
export const getManual = () => Cookies.get(manual)
export const setManual = (value: string) => Cookies.set(manual, value)
export const removeManual = () => Cookies.remove(manual)
